module.exports = __webpack_public_path__ + "img/buddy_whiskers-06.cbb19a5a.svg";